// src/components/contact-directory/ContactTopicTagsReadonly.tsx
import { useState } from "react";

/** Read-only topic chips: shows up to three tags, with an expand control like the admin topic picker. */
export function ContactTopicTagsReadonly(props: { topics: string[]; align?: "start" | "end"; className?: string }) {
  const { topics, align = "start", className = "" } = props;
  const [expanded, setExpanded] = useState(false);

  if (!topics.length) {
    return <div className={"text-[11px] text-gray-500 " + className}>No topic tags</div>;
  }

  const hiddenCount = topics.length - 3;
  const showExpand = hiddenCount > 0;
  const visible = expanded || !showExpand ? topics : topics.slice(0, 3);
  const wrapAlign = align === "end" ? "justify-end sm:justify-start" : "justify-start";

  return (
    <div className={"relative " + (showExpand && !expanded ? "max-h-14 overflow-hidden pr-9 " : "") + className}>
      <div className={"flex flex-wrap gap-1.5 " + wrapAlign}>
        {visible.map((t) => (
          <span
            key={t}
            className="inline-flex max-w-full truncate px-2 py-0.5 rounded-full text-[11px] font-medium border border-indigo-200 bg-indigo-50 text-indigo-900"
            title={t}
          >
            {t}
          </span>
        ))}
      </div>
      {showExpand ? (
        <button
          type="button"
          className="absolute bottom-0 right-0 h-6 w-6 rounded border border-gray-300 bg-white text-xs text-gray-700 hover:bg-gray-50"
          aria-expanded={expanded}
          aria-label={expanded ? "Show fewer topic tags" : `Show ${hiddenCount} more topic tags`}
          onClick={() => setExpanded((v) => !v)}
        >
          {expanded ? "«" : "…"}
        </button>
      ) : null}
    </div>
  );
}
